module.exports = __webpack_public_path__ + "images/home-1-1c7edc4773.png";